import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { AuthApi, DatacenterApi } from 'vrlcm-gui-api';
import {
  EnvironmentState,
  GroupMetadata,
  RequestType,
  User,
  VCenter,
  VcfInfraData
} from 'vrlcm-gui-types';
import { isVcfPoweredProduct } from 'vrlcm-gui-utils';
import {
  initializeStepInfraFailed,
  initializeStepInfraSuccess
} from '../../../actions/workflows/steps/Infrastructure';
import InfrastructureStepAPI from '../../../api/workflows/steps/Infrastructure';
import { ValidateScaleOutOvaResult } from '../../../components/environments/actions/pre-add-component-alert/types';
import * as Constants from '../../../constants/action-constants';
import { StoreState } from '../../../types';

function* initializeStepInfra() {
  try {
    const {
      requestType,
      environmentRequestDTO
    }: EnvironmentState = yield select(
      (s: StoreState) => s.environmentWorkflow.state
    );
    const {
      environmentId,
      infrastructure: { properties: infrastructure },
      products
    } = environmentRequestDTO;
    const allVCenters: VCenter[] = yield call(
      DatacenterApi.getVCenters,
      infrastructure.dataCenterVmid
    );
    const vCenters = allVCenters.filter(
      vCenter => vCenter.vcDataCollectionStatus === 'SUCCESS'
    );
    const groups: GroupMetadata[] = yield call(
      InfrastructureStepAPI.getInfrastructureMetadata
    );
    const infraProperties = groups.find(g => g.name === 'environmentInfra');
    const vCentersDetails = yield all(
      vCenters.map(vCenter => {
        return call(
          DatacenterApi.getVCenter,
          infrastructure.dataCenterVmid,
          vCenter.vCenterName
        );
      })
    );
    if (infraProperties) {
      const user: User = yield call(AuthApi.whoAmI);
      const fetchVcfProperties = isVcfPoweredProduct(
        environmentRequestDTO,
        user
      );
      let vcfInfraData: VcfInfraData | undefined;
      if (fetchVcfProperties) {
        try {
          vcfInfraData = yield call(
            InfrastructureStepAPI.getPropertiesFromVcf,
            products[0].id
          );
        } catch (e) {
          /** */
        }
      }
      let validateScaleOutResult: ValidateScaleOutOvaResult | undefined;
      const validateScaleOutOva =
        requestType === RequestType.ADD_NODE &&
        ['vra'].includes(products[0].id);
      if (validateScaleOutOva) {
        try {
          validateScaleOutResult = yield call(
            InfrastructureStepAPI.getValidateScaleOutOvaResult,
            environmentId,
            products[0].id,
            products[0].version
          );
        } catch (e) {
          /* Do nothing as it by default undefined */
        }
      }
      yield put(
        initializeStepInfraSuccess(
          vCentersDetails,
          infraProperties.properties,
          vcfInfraData,
          validateScaleOutResult
        )
      );
    }
  } catch (e) {
    yield put(initializeStepInfraFailed());
  }
}

function* watchForInfrastructure() {
  yield takeLatest(Constants.INITIALIZE_STEP_INFRA, initializeStepInfra);
}

export default function* infrastructureSaga() {
  yield all([watchForInfrastructure()]);
}
